import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { authenticatedRoute } from '@/router/authenticated-route';
import { requireWorkspace } from '@/router/require-workspace';
import {
  AttestationViewerPage,
  ResumeViewerPage,
} from '@/features/candidates/document-viewer/DocumentViewerPage';

/**
 * EU-594 (fatia 2) — visualizadores de currículo e laudo do candidato,
 * alcançados pelos links da tela de perfil (`/candidatos/$userId`). Mesma
 * receita workspace-scoped do perfil: `?companyId=` viaja na URL e o guard
 * devolve pra Home quando a área de trabalho nunca foi selecionada.
 */
const CandidateDocumentSearchSchema = z
  .object({
    companyId: z.string().uuid().optional().catch(undefined),
  })
  .strip();

export const candidateResumeViewerRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/candidatos/$userId/curriculo',
  validateSearch: CandidateDocumentSearchSchema,
  beforeLoad: requireWorkspace,
  component: ResumeViewerPage,
});

export const candidateAttestationViewerRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/candidatos/$userId/laudo',
  validateSearch: CandidateDocumentSearchSchema,
  beforeLoad: requireWorkspace,
  component: AttestationViewerPage,
});
